import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';
class LeakSourceAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'leaksource';
}

export default new LeakSourceAPI();
